import { ChangeDetectionStrategy, Component, Input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';

import { ButtonComponent, TooltipDirective } from '@blaze-shared/shared-ui';

import { ApiActionStatus, type ApiBuilderAction } from '../api-builder.model';

@Component({
  selector: 'blaze-test-action-btn',
  imports: [ButtonComponent, MatIconModule, MatTooltipModule, TooltipDirective],
  templateUrl: './test-action-btn.component.html',
  styleUrls: ['./test-action-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TestActionBtnComponent {
  confirmClick = output<void>();
  testClick = output<void>();

  @Input() action!: ApiBuilderAction;
  @Input() showValidation = false;
  @Input() valid = false;

  get isPristine(): boolean {
    return this.action.status === ApiActionStatus.PRISTINE;
  }

  get isSuccess(): boolean {
    return this.action.status === ApiActionStatus.STAGING;
  }

  get isInProgress(): boolean {
    return this.action.status === ApiActionStatus.TESTING;
  }

  get isConfirmed(): boolean {
    return this.action.status === ApiActionStatus.CONFIRMED;
  }

  get isError(): boolean {
    return this.action.status === ApiActionStatus.ERROR;
  }

  get isNotTested(): boolean {
    return this.action.data.isTested !== true;
  }
}
